module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/clip-7c50d511998b0fbccabdffad827e4464.svg";